import React from 'react';
import styles from '../css/privacy.module.css'

const PrivacyPolicy = () => {

  return (
    <div className={styles.wrapper}>
        {/* 제목 */}
        <h2 className={styles.title}>개인정보 처리방침</h2>

        {/* 내용 */}
        <div className={styles.contents} style={{whiteSpace: "pre-wrap" }}>
          <div>
              <p>
                {"주식회사 로컬(이하 “회사”)은 「개인정보 보호법」 및 「위치정보의 보호 및 이용 등에 관한 법률」 등 관련 법령을 준수하며, 이용자(가맹점, 배달 파트너 등)의 개인정보 및 위치정보를 보호하고 관련 고충을 신속하고 원활하게 처리하기 위하여 다음과 같이 개인정보 처리방침을 수립·공개합니다."}
              </p>
              <p>{"\n"}</p>
              <p>
                {"본 개인정보 처리방침은 회사가 제공하는 배달대행 플랫폼 서비스(관제 프로그램, 기사 앱, 상점 앱 및 관련 웹 서비스) 이용 시 적용됩니다."}
              </p>
              <p>{"\n"}</p>
              <p><strong>{"제1조 (개인정보의 처리 목적)"}</strong></p>
              <p>
                {"회사는 다음의 목적을 위하여 개인정보를 처리합니다. 처리하고 있는 개인정보는 다음 목적 이외의 용도로는 이용되지 않으며, 이용 목적이 변경되는 경우 관련 법령에 따라 필요한 조치를 이행합니다.\n"}
                {"\t1.  "}<strong>{"가맹점(상점) 관리: "}</strong>{"서비스 가입 의사 확인, 본인 식별 및 인증, 배달대행 서비스 제공, 계약 체결 및 유지, 서비스 부정 이용 방지, 고지·통지, 민원 처리\n"}
                {"\t2.  "}<strong>{"배달 파트너(기사) 관리: "}</strong>{"배달 업무 수행 자격 확인, 배차 시스템 제공, 배송 수행 내역 관리, 정산 및 지급 처리, 사고 및 분쟁 처리\n"}
                {"\t3.  "}<strong>{"서비스 제공 및 정산: "}</strong>{"주문 접수, 배차 처리, 배송 관리, 배송 경로 최적화, 서비스 이용 요금 정산, 세금계산서 발급, 배달 수수료 지급\n"}
                {"\t4.  "}<strong>{"위치 기반 서비스 제공: "}</strong>{"배달 파트너의 실시간 위치 확인, 가맹점 및 주문 고객에게 배송 진행 상황 안내, 배달 동선 최적화\n"}
                {"\t5.  "}<strong>{"고객 문의 및 분쟁 대응: "}</strong>{"서비스 이용 기록 관리, 민원 처리 및 분쟁 대응\n"}
              </p>
              <p>{"\n"}</p>
              <p><strong>{"제2조 (처리하는 개인정보의 항목 및 수집 방법)"}</strong></p>
              <p>{"회사는 서비스 제공을 위하여 필요한 최소한의 개인정보를 수집합니다.\n"}</p>
              
              <p><strong>{"① 가맹점(상점)"}</strong></p>
              <p>{"\t•  "}<strong>{"필수항목: "}</strong>{"사업자등록번호, 상호명, 대표자명, 사업장 주소, 유선전화번호, 담당자 휴대전화번호, 정산 계좌정보(은행명, 예금주, 계좌번호), 사업자등록증 사본\n"}</p>
              
              <p><strong>{"② 배달 파트너(기사)"}</strong></p>
              <p>{"\t•  "}<strong>{"필수항목: "}</strong>{"성명, 생년월일, 휴대전화번호, 아이디(ID), 비밀번호, 위치정보(GPS 및 기지국 기반), 운전면허 정보(면허번호, 발급일), 차량 또는 이륜차 번호, 유상운송 보험 가입 정보, 정산 계좌정보\n"}</p>
              <p>{"\t•  "}<strong>{"선택항목: "}</strong>{"프로필 사진, 교통법규 위반 확인을 위한 통고처분 및 범칙금 납부 내역\n"}</p>
              <p>{"\t•  "}<strong>{"고유식별정보 (관련 법령에 따른 필수 수집): "}</strong>{"주민등록번호\n"}</p>
              <p>{"(※ 목적: 소득세법 제145조 등에 따른 원천징수영수증 발급 및 세금 신고 목적에 한하여 처리하며, 목적 달성 후 지체 없이 파기합니다.)"}</p>
              
              <p><strong>{"③ 주문 고객 정보 (수탁 처리 정보)"}</strong></p>
              <p>{"회사는 가맹점 또는 외부 주문 플랫폼으로부터 배달 수행을 위해 다음 정보를 위탁받아 처리할 수 있습니다."}</p>
              <p>{"\t•  "}<strong>{"처리항목: "}</strong>{"주문자 연락처(안심번호 포함), 배송지 주소, 주문(물품) 정보\n"}</p>
              <p>{"\t•  "}<strong>{"처리목적: "}</strong>{"배달 수행, 배송 관리, 배송 이력 관리\n"}</p>
              <p>{"\t•  "}<strong>{"보유기간: "}</strong>{"배송 완료 및 정산 확인 후 지체 없이 파기 (단, 관련 법령에 따라 보관이 필요한 경우 해당 기간 동안 보관)\n"}</p>

              <p><strong>{"④ 스마트폰 앱 서비스 이용 시 접근권한"}</strong></p>
              <p>
                {"기사 앱 및 상점 앱에서 다음 권한이 사용될 수 있습니다. (기기 설정 메뉴를 통해 권한을 철회할 수 있습니다.)\n"}
                {"\t•  "}<strong>{"필수 접근권한:* "}</strong>{"위치정보 (배차 및 경로 안내, 백그라운드 위치 포함)\n"}
                {"\t\to  사진 및 미디어 파일 접근 (배송 완료 사진 업로드 및 파일 저장)\n"}
                {"\t\to  전화 (고객 및 상점 통화 연결)\n"}
                {"\t•  "}<strong>{"선택 접근권한:* "}</strong>{"카메라 (배송 완료 사진 촬영, 서류 제출)\n"}
                {"\t\to  알림 (푸시 메시지 수신)\n"}
              </p>

              <p><strong>{"⑤ 서비스 이용 과정에서 자동 수집되는 정보"}</strong></p>
              <p>
                {"\t•  IP 주소, 쿠키, 서비스 접속 기록, 기기 정보(OS, 모델명, 앱 버전 등), 불량 이용 기록"}
              </p>

              <p><strong>{"⑥ 개인정보 수집 방법"}</strong></p>
              <p>
                {"\t1.  서비스 회원가입 및 이용 과정에서 이용자가 직접 입력\n"}
                {"\t2.  가맹점 또는 외부 주문 플랫폼을 통한 정보 제공 (API 연동 등)\n"}
                {"\t3.  모바일 애플리케이션 실행 및 이용 과정에서 자동 수집\n"}
                {"\t4.  고객센터 상담 및 문의 과정"}
              </p>
              <p>{"\n"}</p>
              <p><strong>{"제3조 (개인정보의 보유 및 이용 기간)"}</strong></p>
              <p>
                {"회사는 원칙적으로 개인정보 처리 목적이 달성되면 해당 정보를 지체 없이 파기합니다. 다만 다음의 경우 관련 법령에 따라 일정 기간 보관합니다."}
              </p>
              <table>
                <thead>
                  <tr>
                    <th>{"보관 항목"}</th>
                    <th>{"보관 기간"}</th>
                    <th>{"관련 법령"}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>{"계약 또는 청약철회 등에 관한 기록"}</td>
                    <td>{"5년"}</td>
                    <td>{"전자상거래법"}</td>
                  </tr>
                  <tr>
                    <td>{"대금결제 및 재화 등의 공급에 관한 기록"}</td>
                    <td>{"5년"}</td>
                    <td>{"전자상거래법"}</td>
                  </tr>
                  <tr>
                    <td>{"소비자의 불만 또는 분쟁처리에 관한 기록"}</td>
                    <td>{"3년"}</td>
                    <td>{"전자상거래법"}</td>
                  </tr>
                  <tr>
                    <td>{"세법이 규정하는 장부 및 증빙서류"}</td>
                    <td>{"5년"}</td>
                    <td>{"국세기본법"}</td>
                  </tr>
                  <tr>
                    <td>{"서비스 접속(로그) 기록"}</td>
                    <td>{"3개월"}</td>
                    <td>{"통신비밀보호법"}</td>
                  </tr>
                </tbody>
              </table>

              <p>{"\n"}</p>
              <p><strong>{"제4조 (개인정보의 제3자 제공)"}</strong></p>
              <p>
                {"회사는 정보주체의 동의 없이 개인정보를 제3자에게 제공하지 않습니다. 다만, 원활한 배달대행 서비스 수행을 위해 다음과 같이 개인정보를 제공할 수 있습니다."}
              </p>

              <table>
                <thead>
                  <tr>
                    <th>{"제공받는 자"}</th>
                    <th>{"제공 목적"}</th>
                    <th>{"제공 항목"}</th>
                    <th>{"보유 기간"}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>{"배달을 요청한 가맹점"}</td>
                    <td>{"배달 서비스 수행"}</td>
                    <td>{"(가맹점) 상호명, 주소"}</td>
                    <td>
                      {"서비스 제공 완료 후 즉시 파기\n"}
                      {"(단, 관련 법령에 따라 일정 기간 보관될 수 있음)"}
                    </td>
                  </tr>
                  <tr>
                    <td>{"주문 고객(수령인)"}</td>
                    <td>{"배송 진행 상황 안내"}</td>
                    <td>{"(기사) 성명, 연락처, 실시간 위치 정보"}</td>
                    <td>
                      {"서비스 제공 완료 후 즉시 파기\n"}
                      {"(단, 관련 법령에 따라 일정 기간 보관될 수 있음)"}
                    </td>
                  </tr>
                  <tr>
                    <td>{"외부 연동 플램폼"}</td>
                    <td>{"배달 서비스 수행 및 상태 연동"}</td>
                    <td>{"상동 기재 항목과 동일"}</td>
                    <td>
                      {"서비스 제공 완료 후 즉시 파기\n"}
                      {"(단, 관련 법령에 따라 일정 기간 보관될 수 있음)"}
                    </td>
                  </tr>
                  <tr>
                    <td>{"제휴 보험사"}</td>
                    <td>{"보험 가입 및 사고 처리"}</td>
                    <td>{"(기사) 성명, 생년월일, 연락처"}</td>
                    <td>
                      {"서비스 제공 완료 후 즉시 파기\n"}
                      {"(단, 관련 법령에 따라 일정 기간 보관될 수 있음)"}
                    </td>
                  </tr>
                </tbody>
              </table>
              
              <p>{"\n"}</p>
              <p><strong>{"제5조 (개인정보 처리의 위탁)"}</strong></p>
              <p>
                {"회사는 서비스 제공을 위해 다음과 같이 개인정보 처리 업무를 위탁할 수 있으며, 위탁 계약 체결 시 개인정보 보호 관련 법령을 준수하도록 관리·감독합니다.\n"}
                {"\t•  "}<strong>{"[헥토파이낸셜]: "}</strong>{"서비스 이용요금 결제 및 정산\n"}
                {"\t•  "}<strong>{"[AWS]: "}</strong>{"서버 운영 및 데이터 보관\n"}
                {"\t•  "}<strong>{"[헥토파이낸셜]: "}</strong>{"본인 인증\n"}
              </p>
              
              <p>{"\n"}</p>
              <p><strong>{"제6조 (위치정보의 처리 및 보호)"}</strong></p>
              <p>
                {"회사는 배달대행 서비스 제공을 위해 배달 파트너의 위치정보를 수집·이용할 수 있습니다.\n"}
                {"① "}<strong>{"수집 목적: "}</strong>{"배달기사 위치 확인, 최적 배차 수행, 배송 진행 상황 안내, 배송 분쟁 해결\n"}
                {"② "}<strong>{"보유 기간: "}</strong>{"위치정보는 목적 달성 후 지체 없이 파기합니다. 단, 배송 내역 검증 및 고객 문의 대응을 위해 배달 완료 시점으로부터 최대 6개월 범위 내에서 위치정보 처리 기록을 보관할 수 있습니다.\n"}
                {"③ "}<strong>{"권리 행사: "}</strong>{"배달 파트너는 단말기 설정을 통해 위치정보 수집을 제한할 수 있습니다. 다만 이 경우 정상적인 배차 및 서비스 이용이 어려울 수 있습니다.\n"}
                {"④ "}<strong>{"위치정보 이용약관: "}</strong>{"위치정보 처리에 관한 보다 상세한 사항은 회사의 '위치기반서비스 이용약관'에서 별도로 규정합니다."}
              </p>

              <p>{"\n"}</p>
              <p><strong>{"제7조 (정보주체의 권리 및 행사 방법)"}</strong></p>
              <p>
                {"① 정보주체는 언제든지 개인정보 열람 요구, 정정 요구, 삭제 요구, 처리 정지 요구의 권리를 행사할 수 있습니다.\n"}
                {"② 권리 행사는 회사에 대해 서면, 전화, 이메일 등을 통하여 하실 수 있으며 회사는 지체 없이 조치하겠습니다. 회원 탈퇴(동의 철회)를 원하시는 경우 앱 내 '회원탈퇴' 기능을 이용하거나 고객센터로 연락하여 처리할 수 있습니다.\n"}
              </p>

              <p>{"\n"}</p>
              <p><strong>{"제8조 (개인정보의 파기 절차 및 방법)"}</strong></p>
              <p>
                {"회사는 개인정보 보유 기간이 경과하거나 처리 목적이 달성된 경우 지체 없이 개인정보를 파기합니다.\n"}
                {"\t•  "}<strong>{"전자적 파일 형태: "}</strong>{"복구 및 재생이 불가능한 기술적 방법으로 영구 삭제\n"}
                {"\t•  "}<strong>{"종이 문서: "}</strong>{"분쇄 또는 소각\n"}
              </p>
              
              <p>{"\n"}</p>
              <p><strong>{"제9조 (개인정보의 안전성 확보 조치)"}</strong></p>
              <p>
                {"회사는 개인정보 보호를 위해 다음과 같은 조치를 시행합니다.\n"}
                {"\t1. "}<strong>{"관리적 조치: "}</strong>{"내부관리계획 수립 및 시행, 정기적인 직원 보안 교육\n"}
                {"\t2. "}<strong>{"기술적 조치: "}</strong>{"개인정보처리시스템 접근 권한 관리, 개인정보 암호화, 보안 프로그램 설치 및 갱신\n"}
                {"\t3. "}<strong>{"물리적 조치: "}</strong>{"전산실 및 자료보관실 접근 통제\n"}
              </p>
              
              <p>{"\n"}</p>
              <p><strong>{"제10조 (개인정보 보호책임자 및 권익침해 구제방법)"}</strong></p>
              <p>
                {"① 회사는 개인정보 처리에 관한 업무를 총괄해서 책임지고, 정보주체의 불만 처리 및 피해 구제 등을 위하여 아래와 같이 개인정보 보호책임자를 지정하고 있습니다.\n"}
                {"\t•  "}<strong>{"책임자 성명: "}</strong>{"이현우\n"}
                {"\t•  "}<strong>{"소속/직책: "}</strong>{"연구소장\n"}
                {"\t•  "}<strong>{"연락처: "}</strong>{"1800-1321\n"}
                {"\t•  "}<strong>{"이메일: "}</strong>{"catchdev0@gmail.com\n"}
                {"\t•  "}<strong>{"주소: "}</strong>{"서울특별시 마포구 월드컵북로 396 (상암동, 누리꿈스퀘어) 1005호\n\n"}

                {"② 정보주체는 개인정보침해로 인한 구제를 받기 위하여 아래의 기관에 분쟁해결이나 상담 등을 신청할 수 있습니다.\n"}
                {"\t•  개인정보분쟁조정위원회 : (국번없이) 1833-6972 (www.kopico.go.kr)\n"}
                {"\t•  개인정보침해신고센터 : (국번없이) 118 (privacy.kisa.or.kr)\n"}
                {"\t•  대검찰청 : (국번없이) 1301 (www.spo.go.kr)\n"}
                {"\t•  경찰청 : (국번없이) 182 (ecrm.cyber.go.kr)"}
              </p>

              <p>{"\n"}</p>
              <p><strong>{"제11조 (개인정보 처리방침 변경)"}</strong></p>
              <p>
                {"본 개인정보 처리방침은 관련 법령 또는 회사 정책에 따라 변경될 수 있으며 변경 시 시행일 기준 최소 7일 전부터 회사 홈페이지 또는 서비스 내 공지사항을 통해 안내합니다."}
              </p>

              <p>{"\n"}</p>
              <p><strong>{"부칙"}</strong></p>
              <p>{"본 개인정보 처리방침은 2026년 3월 13일부터 시행됩니다."}</p>
          </div>
        </div>
    </div>
  );
}

export default PrivacyPolicy;
